var chunkToChildrenMap = {
	"94": [
		7639,
		2495
	],
	"1351": [
		7639
	],
	"4120": [
		7639,
		2495
	],
	"5112": [
		109,
		6140
	],
	"5368": [
		7919,
		109,
		6140,
		5898
	],
	"8034": [
		7639,
		2495
	],
	"8182": [
		7639,
		2495
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));